import styled from "styled-components";
import getSpacing from "./spacing";

export default styled.div`
  padding: ${getSpacing};
  box-sizing: border-box;
`;



// WEBPACK FOOTER //
// ./src/components/common/spacing/Padding.js